import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface CollectionItemCardStylesClasses {
  root: string;
  card: string;
  details: string;
  content: string;
  cover: string;
  controls: string;
  playIcon: string;
}

const useCollectionItemCardStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  card: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    width: '100%',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '20px',
  },
  content: {
    flex: '1 0 auto',
    padding: '8px 0px',
  },
  cover: {
    maxWidth: '160px',
    maxHeight: '90px',
    minWidth: '80px',
    minHeight: '45px',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
}));

export type { CollectionItemCardStylesClasses };
export default useCollectionItemCardStyles;
